import { httpClient } from '../transports/http.js'
import settings from '../../../public/settings.json'

const imageFormats = ['png', 'jpeg', 'jpg', 'mov', 'mp4']

export async function getAllAttachments({ table, keyValue }) {
  const result = (await httpClient.post('api/GETALLATTACHMENTS', { TABLE: table, KEYVALUE: keyValue })).data
  if (result && result.length) {
    const files = []
    await result.filter(
      attachment => imageFormats.includes(attachment.FILEEXT.toLowerCase())
    ).reduce(
      (series, attachment) => {
        return series.then(() => {
          return getAttachment({ table: table, keyValue: keyValue, attachmentId: attachment.NDOR }).then((file) => {
            attachment.name = attachment.FILENAME
            attachment.FILENAME = file.FILENAME
            attachment.FILETYPE = file.FILETYPE
            attachment.filePath = file.filePath
            files.push(attachment); return attachment
          })
        })
      },
      Promise.resolve())
    result.filter(
      attachment => !imageFormats.includes(attachment.FILEEXT.toLowerCase())
    ).forEach(attachment => {
      attachment.name = attachment.FILENAME
      attachment.FILETYPE = attachment.FILEEXT
      files.push(attachment)
    })
    return files
  }
}
  
export async function getAttachmentById({ ID }) {
  const result = (await httpClient.post('api/GETATTACHMENTEX', { ID })).data
  if (result && result.FILENAME) {
    result.filePath = settings.wsPath + 'GetFile.ashx?file=' + result.FILENAME
  }
  return result
}

export async function addAttachment(params) {
  return httpClient.post('api/ADDATTACHMENTEX', params)
}

export async function getAttachment({ table, keyValue, attachmentId }) {
  const result = await (await httpClient.post('api/GETATTACHMENT', { TABLE: table, KEYVALUE: keyValue, NDOR: attachmentId, PDF: false })).data
  if (result && result.FILENAME) {
    result.filePath = settings.wsPath + 'GetFile.ashx?file=' + result.FILENAME
  }
  return result
}
  